var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HCases row-container"},[_c('TitleBar',{attrs:{"msg":_vm.msg}}),_c('HCaseNew')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }